/**
 * teacher
 */
export default {
    name: 'teacher',
    path: '/teacher',
    meta: {},
    component: () => import('@/views/teacher/Home'),
    children: [
        {
            // 学期报告
            name: 'term_paper_detail',
            path: 'term_paper/detail',
            meta: {},
            component: () => import('@/views/teacher/term_paper/Detail'),
        },
        {
            // Loading
            name: 'term_paper_landing',
            path: 'term_paper/landing',
            meta: {},
            component: () => import('@/views/teacher/term_paper/Landing'),
        },
        {
            //活动 /swan/labrador/src/views/teacher/activity/2021/Summer.vue
            name: 'activity_2021_summer',
            path: 'activity/2021/summer',
            meta: {},
            component: () => import('@/views/teacher/activity/2021/Summer'),
        },
        {
            // 校园活动
            name: 'campusActivities',
            path: 'campusActivities',
            meta: {},
            component: () => import('@/views/teacher/campusActivities/Home'),
            children: [
                {
                    // 活动模板列表
                    name: 'templateList',
                    path: 'templateList',
                    meta: {
                        title: '活动列表',
                    },
                    component: () => import('@/views/teacher/campusActivities/TemplateList'),
                    children: [],
                },
                {
                    // 活动介绍
                    name: 'ActivityIntroduction',
                    path: 'ActivityIntroduction',
                    meta: {
                        title: '活动介绍',
                    },
                    component: () =>
                        import('@/views/teacher/campusActivities/ActivityIntroduction'),
                    children: [],
                },
                {
                    // 知识点
                    name: 'KnowledgePoints',
                    path: 'KnowledgePoints',
                    meta: {},
                    component: () => import('@/views/teacher/campusActivities/KnowledgePoints'),
                    children: [],
                },
                {
                    //活动报告
                    name: 'ActivityReport',
                    path: 'ActivityReport',
                    meta: {
                        title: '活动报告',
                    },
                    component: () => import('@/views/teacher/campusActivities/ActivityReport'),
                    children: [],
                },
                {
                    //布置成功及分享
                    name: 'SuccessShare',
                    path: 'SuccessShare',
                    meta: {
                        title: '布置成功',
                    },
                    component: () => import('@/views/teacher/campusActivities/SuccessShare'),
                    children: [],
                },
                {
                    //配置活动规则
                    name: 'ConfigurationRules',
                    path: 'ConfigurationRules',
                    meta: {
                        title: '配置活动规则',
                        keepAlive: true,
                    },
                    component: () => import('@/views/teacher/campusActivities/ConfigurationRules'),
                    children: [],
                },
                {
                    //配置活动关卡
                    name: 'ConfigurationLevel',
                    path: 'ConfigurationLevel',
                    meta: {
                        title: '配置活动规则',
                    },
                    component: () => import('@/views/teacher/campusActivities/ConfigurationLevel'),
                    children: [],
                },
                {
                    //选择学期和教材
                    name: 'TermTextbook',
                    path: 'TermTextbook',
                    meta: {
                        title: '选择学期和教材',
                    },
                    component: () => import('@/views/teacher/campusActivities/TermTextbook'),
                    children: [],
                },
                {
                    //题目预览
                    name: 'TopicPreview',
                    path: 'TopicPreview',
                    meta: {
                        title: '题目预览',
                    },
                    component: () => import('@/views/teacher/campusActivities/TopicPreview'),
                    children: [],
                },
                {
                    //题目预览详情
                    name: 'TopicPreviewDetails',
                    path: 'TopicPreviewDetails',
                    meta: {
                        title: '题目预览',
                    },
                    component: () => import('@/views/teacher/campusActivities/TopicPreviewDetails'),
                    children: [],
                },
                {
                    //客服定制
                    name: 'ServiceCustomized',
                    path: 'ServiceCustomized',
                    meta: {
                        title: '客服定制',
                    },
                    component: () => import('@/views/teacher/campusActivities/ServiceCustomized'),
                    children: [],
                },
                {
                    //客服定制成功
                    name: 'ServiceCustomizedSuccess',
                    path: 'ServiceCustomizedSuccess',
                    meta: {
                        title: '客服定制成功',
                    },
                    component: () =>
                        import('@/views/teacher/campusActivities/ServiceCustomizedSuccess'),
                    children: [],
                },
            ],
        },
        {
            // 各种报告
            name: 'report',
            path: 'report',
            meta: {},
            component: () => import('@/views/teacher/report/Home'),
            children: [
                {
                    // 点阵班级答题情况
                    name: 'AnswerReport',
                    path: 'AnswerReport',
                    meta: {
                        title: '班级答题情况',
                    },
                    component: () => import('@/views/teacher/report/lattice/AnswerReport'),
                    children: [],
                },
                {
                    // 点阵班级答题单题
                    name: 'AnswerItemReport',
                    path: 'AnswerItemReport',
                    meta: {
                        title: '班级答题情况单题',
                    },
                    component: () => import('@/views/teacher/report/lattice/AnswerItemReport'),
                    children: [],
                },
                {
                    // 点阵笔帮助中心
                    name: 'HelpCenter',
                    path: 'HelpCenter',
                    meta: {
                        title: '帮助中心',
                    },
                    component: () => import('@/views/teacher/report/lattice/HelpCenter'),
                    children: [],
                },
                {
                    // 个性辅导使用情况
                    name: 'UsageReport',
                    path: 'usage-report',
                    meta: {
                        title: '帮助中心',
                    },
                    component: () =>
                        import('@/views/teacher/report/personalityCounseling/UsageReport'),
                    children: [],
                },
            ],
        },
    ],
};
